import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { IntelligenceSectionTitle } from '../common';
import { rightOfWayLayerIds } from '../common/config';
import { getRollupCount } from '../common/getRollupCount';
import IntelligenceSection from '../common/IntelligenceSection';
import Table from '../common/Table';
import store from '../store';

export default function RightOfWayAndCrossings() {
  const { config } = useSnapshot(store) as typeof store;

  const featureCount = useMemo(() => getRollupCount(config, rightOfWayLayerIds), [config]);

  return (
    <IntelligenceSection title={IntelligenceSectionTitle.RightOfWay} featureCount={featureCount}>
      <Table
        label="Rail"
        columns={['Owner']}
        rows={[{ layerId: 'landUseRailroads', columnProperties: ['rrowner1'] }]}
        emptyMessage="No known rail in the project area."
        sortBy="rrowner1"
      />
      <Table
        label="Transit"
        columns={['Transit Type', 'Agency', 'More']}
        rows={[
          {
            layerId: 'transitRoutes',
            columnProperties: ['route_ty_1', 'agency_id'],
          },
        ]}
        moreInfo={{
          columns: ['Route Name', 'Route Description', 'Route URL'],
          columnProperties: ['route_long', 'route_desc', 'route_url'],
        }}
        sortBy="agency_id"
        emptyMessage="No known transit in the project area"
      />
      <Table
        label="Roads"
        columns={['Agency', 'Street Name']}
        rows={[
          {
            layerId: 'landUseRightOfWay',
            columnProperties: ['ownership_txt', 'streetname'],
          },
        ]}
        sortBy="ownership_txt"
        emptyMessage="No known roads in the project area"
      />
    </IntelligenceSection>
  );
}
